module.exports = __webpack_public_path__ + "assets/img/34_781.113ca84a.jpg";